
import { Component, Vue } from "vue-property-decorator";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
import { BallRoomAPI } from "@/common/api/userOldManage/ballRoomList";
import { CommonApi } from "@/common/api/common";
export const pageApiList = getPageAPIs(BallRoomAPI);

import {
  // commonDefaultBallRoomType2Ch,
  shareConfirmOptions,
  // transferUserLevel2ch,
  defaultUserMemberList,
} from "@/common/config";

@Component({
  filters: {
    // showDeviceTypeName(type: number) {
    //   return commonDefaultBallRoomType2Ch[type] || '未知'
    // }
  }
})
export default class OldBallRoomList extends Vue {
  private utilInstance: any;
  private ballRoomApi: any;
  private commonApi: any;
  private dialogVisible:boolean  = false
  private addForm:any = {
    user_id:'',
    group_id:'',
    group_name:''
  }
  private openType:number = 1 // 1增加 2编辑
  private ballRoomIDList:any = []
  constructor() {
    super();
    this.ballRoomApi = new BallRoomAPI();
    this.commonApi = new CommonApi();
    this.utilInstance = new Util();
  }

  private get userOwnerId() {
    const route = this.$route 

    const {
      query = {}
    } = route || {}

    const {
      userId = ''
    } = query

    return userId
  }

  private firstLoading: boolean = true;

  private form: any = {
    mobile: "", // 手机号
    userId: "", // 用户ID
  };

  private created() {
    this.getBallRoomIDList();
  }

  private allowChildDeviceBtn(row: any) {
    const allowDeviceTypes: number[] = [1, 2, 3, 4, 7]

    return allowDeviceTypes.includes(row.device_type)
  }

  private activated(): void {
    this.getTable();
  }
  private getTable(): void {
    this.ballRoomApi.getBallRoomTableList(
      this.getBallRoomTableListParams(),
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { data } = res;

        const { list, count, page, prepage } = data || {};

        const newTableList = Array.isArray(list)
          ? list.map(this.handleTableData)
          : [];

        this.$set(this.tablePage, "totalCount", count);
        this.$set(this.tablePage, "pageNo", page);
        this.$set(this.tablePage, "pageSize", prepage);

        this.tableData = newTableList;

        this.firstLoading = false;
      },
      () => {
        this.firstLoading = false;
      }
    );
  }

  private getBallRoomIDList() {
    this.ballRoomApi.groupList({}, (res: any) => {
          this.ballRoomIDList = res.data.list
        },
        () => {}
    );
  }

  private getBallRoomTableListParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const firstLoading = this.firstLoading;

    const {
      // userId, // 用户ID
      // userName, // 用户昵称
      // mobile, // 手机号
      // userLevel, // 会员等级
      // invite_code, // 邀请码
      // time, // 时间选择
    } = form || {};

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {
      user_id: this.userOwnerId
    };


    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;

      outerParams.__isUnique = !firstLoading;
    }

    console.log(outerParams, "outerParams");

    return outerParams;
  }

  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    const {} = data;

    const newData = {
      ...data,
    };

    return newData;
  }

  private addEditForm(type:number=1,row:any={}){
    this.addForm = new Util().clearObject(this.addForm);
    this.openType = type
    if(this.openType===2){
      this.addForm = {...row}
    }
    this.dialogVisible = true
  }

  private handleComfirm() {
    this.addForm.user_id = this.userOwnerId
    if(this.openType===1){
      this.ballRoomApi.addBallRoom(this.addForm,
          () => {
            this.$message.success('新增成功');
            this.dialogVisible = false;
            this.getTable();
          },
          () => {
          }
      );
    }else{
      this.ballRoomApi.editBallRoom(this.addForm,
          () => {
            this.$message.success('编辑成功');
            this.dialogVisible = false;
            this.getTable();
          },
          () => {
          }
      );
    }

  }

  private onGoDeviceChildList(deviceGateItem: any) {
    const {
      group_id
    } = deviceGateItem || {}

    if (group_id) {
      this.$router.push({
        path: "/oldDeviceList",
        query: {
          group_id: group_id,
        },
      });
    }
  }

  private deleteBallRoom(deviceGateItem: any) {
    const set = Util.setListProp
    this.$confirm(`确定删除该球房吗?`, "", {
      ...shareConfirmOptions,
    }).then(() => {
      set(
        this,
        this.tableData,
        deviceGateItem,
        "__unbindLoading",
        true
      );

      this.ballRoomApi.removeBallRoom({
            id: deviceGateItem.id
      },() => {
          set(
            this,
            this.tableData,
            deviceGateItem,
            "__unbindLoading",
            false
          );
          this.getTable();
        },
        () => {
          set(
            this,
            this.tableData,
            deviceGateItem,
            "__unbindLoading",
            false
          );
        })

    })
  }



  private restForm(): void {
    this.form = this.utilInstance.clearObject(this.form);

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }
}
